import { Component, ViewEncapsulation, OnInit } from '@angular/core';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

	currentYear: number = new Date().getFullYear();

}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts